'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndDrugNone } from '../../Entities/Ind/IndDrugNone';
export class IndDrugNoneRepository extends CoreRepository {
  public createIndDrugNone(indId: number, payload: any[]) {
    return this.webAPI.createIndDrugNone(indId, payload).then((response) => {
      const indDrug2 = new IndDrugNone();
      indDrug2.hydrate(response);

      return indDrug2;
    });
  }

  public removeIndDrugNone(indId: number, indDrug2Id: number) {
    return this.webAPI.removeIndDrugNone(indId, indDrug2Id).then((response) => {
      return response;
    });
  }

  /*
    public getIndDrugNone(options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getIndDrugNone(options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let IndDrugNone = new IndDrugNone();
            IndDrugNone.hydrate(response);

            return IndDrugNone;
        });
    }

    public createIndDrugNone(payload: object = {}){  
    return this.webAPI.createIndDrugNone(payload)
      .then( response => {
        let IndDrugNone = new IndDrugNone();
        IndDrugNone.hydrate(response);

        return IndDrugNone;
      });
    }

    public updateIndDrugNone(payload: object = {}){  
        return this.webAPI.updateIndDrugNone(payload)
        .then( response => {
            let IndDrugNone = new IndDrugNone();
            IndDrugNone.hydrate(response);

            return IndDrugNone;
        });
    }

    public removeIndDrugNone( ){
        return this.webAPI.removeIndDrugNone()
        .then( response => {
            return response;
        });
    }
    */
}
